import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/end-reasons');
export const getAll = () => req('GET', `/`);
//# sourceMappingURL=end-reasons.js.map